import { useTheme } from '@fluentui/react';
import { makeReadableColor } from '../../utils/colorUtils';

const colorDict: Record<string, string> = {};

function useReadableColor(baseColor: string, backgroundColor = '', thresholdContrast = 3.5): string {
  const { palette: { white } } = useTheme();
  backgroundColor = backgroundColor || white;

  const colorKey = `${baseColor}-${backgroundColor}-${thresholdContrast}`;

  if (colorDict[colorKey] === undefined)
    colorDict[colorKey] = makeReadableColor(baseColor, backgroundColor, thresholdContrast, 2.5);

  return colorDict[colorKey];
}

export default useReadableColor;